import React, { useState } from 'react';
import './Project.css';

// Import your images from assets
import project1_1 from '../../Assets/Project/1img (1).png';
import project1_2 from '../../Assets/Project/1img (2).png';
import project1_3 from '../../Assets/Project/1img (3).png';
import project1_4 from '../../Assets/Project/1img (4).png';
import project2_1 from '../../Assets/Project/2img (1).png';
import project2_2 from '../../Assets/Project/2img (2).png';
import project2_3 from '../../Assets/Project/2img (3).png';
import project2_4 from '../../Assets/Project/2img (4).png';
import project3_1 from '../../Assets/Project/3img (1).png';
import project3_2 from '../../Assets/Project/3img (2).png';
import project3_3 from '../../Assets/Project/3img (3).png';
import project3_4 from '../../Assets/Project/3img (4).png';
import project4_1 from '../../Assets/Project/4img (1).png';
import project4_2 from '../../Assets/Project/4img (2).png';
import project4_3 from '../../Assets/Project/4img (3).png';
import project4_4 from '../../Assets/Project/4img (4).png';

const projectData = [
  {
    id: 1,
    category: "Nitrile Rubber Insulation",
    location: "Chennai",
    year: "2025",
    images: [project1_1, project1_2, project1_3, project1_4]
  },
  {
    id: 2,
    category: "Thermal Insulation",
    location: "Coimbatore",
    year: "2024",
    images: [project2_1, project2_2, project2_3, project2_4]
  },
  {
    id: 3,
    category: "Hot Insulation",
    location: "Chennai",
    year: "2025",
    images: [project3_1, project3_2, project3_3, project3_4]
  },
  {
    id: 4,
    category: "Boiler Insulation",
    location: "Mumbai",
    year: "2025",
    images: [project4_1, project4_2, project4_3, project4_4]
  }
];

const Projects = () => {
  // State to handle the Lightbox
  const [selectedImg, setSelectedImg] = useState(null);

  const openLightbox = (src) => {
    setSelectedImg(src);
    // Prevent background scrolling when lightbox is open
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImg(null);
    // Restore scrolling
    document.body.style.overflow = 'auto';
  };

  return (
    <section className="projects-section">
      <div className="projects-container">
        <h2 className="projects-main-title">The Latest Projects</h2>
        
        <div className="projects-grid">
          {projectData.map((project) => (
            <div key={project.id} className="project-group">
              <div className="project-image-row">
                {project.images.map((src, index) => (
                  <div 
                    key={index} 
                    className="project-img-wrapper"
                    onClick={() => openLightbox(src)} // Trigger Lightbox
                  >
                    <img src={src} alt={project.category} />
                  </div>
                ))}
              </div>

              <div className="project-info">
                <div className="info-left">
                  <h3>{project.category}</h3>
                  <p>{project.location}</p>
                </div>
                <div className="info-right">
                  <span className="project-year">{project.year}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Overlay */}
      {selectedImg && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>&times;</button>
            <img src={selectedImg} alt="Enlarged Project" className="lightbox-img" />
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;